export default __webpack_public_path__ + "static/media/Snow_Day.95a5088b.jpg";